import {
  ASPIRE_CREDIT_CARD_ID,
  IPAY_ALIPAY_ID,
  IPAY_QRIS_ID,
  IPAY_UNIONPAY_ID,
  IPAY_WECHAT_PAY_ID,
} from 'common/constants'

const paymentMethodMap = {
  [Number(ASPIRE_CREDIT_CARD_ID)]: {
    code: 'credit_card',
    id: Number(ASPIRE_CREDIT_CARD_ID),
    name: 'Aspire Card',
    fee: '3.5',
  },
  [Number(IPAY_UNIONPAY_ID)]: {
    code: 'credit_card',
    id: Number(IPAY_UNIONPAY_ID),
    name: 'UnionPay',
    fee: '3',
  },
  [Number(IPAY_QRIS_ID)]: {
    code: 'digital_wallet',
    id: Number(IPAY_QRIS_ID),
    name: 'QRIS',
    fee: '1',
  },
  [Number(IPAY_WECHAT_PAY_ID)]: {
    code: 'digital_wallet',
    id: Number(IPAY_WECHAT_PAY_ID),
    name: 'WeChat Pay',
    fee: '3',
  },
  [Number(IPAY_ALIPAY_ID)]: {
    code: 'digital_wallet',
    id: Number(IPAY_ALIPAY_ID),
    name: 'Alipay',
    fee: '3',
  },
}

export default paymentMethodMap
